import { Box, Button } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import styles from "./OverwriteFileConfirmation.styles";
import SecureSyncModal from "src/components/common/SecureSyncModal/SecureSyncModal";

const OverwriteFileConfirmation = ({ fileName, open, handleConfirm, onClose }) => {
    const { t } = useTranslation();
    return (
        <SecureSyncModal
            open={open}
            title={t("buttonLabels.delete")}
            footer={
                <Box sx={styles.confirmationModalFooter}>
                    <Button variant="contained" color="primary" onClick={handleConfirm}>
                        {t("buttonLabels.ok")}
                    </Button>
                    <Button autoFocus variant="outlined" onClick={onClose}>
                        {t("buttonLabels.cancel")}
                    </Button>
                </Box>
            }
        >
            <Trans
                i18nKey="messages.overwriteFile"
                values={{ fileName: fileName, buttonLabel: t("buttonLabels.ok") }}
            />
        </SecureSyncModal>
    );
};

export default OverwriteFileConfirmation;
